import { Popper } from '@cian/ui-kit/internal/components/Popper';
import * as React from 'react';

import * as styles from './OnboardingTooltip.css';

interface IOnboardingTooltipProps {
  children: React.ReactElement;
  tooltip: React.ReactNode;
  open?: boolean;
}

export const OnboardingTooltip: React.FC<IOnboardingTooltipProps> = ({ children, tooltip, open }) => {
  const spanRef = React.useRef<HTMLElement>(null);

  return (
    <>
      <span ref={spanRef}>{children}</span>
      <Popper anchorRef={spanRef} placement="left-start" open={open || false}>
        <div className={styles['container']}>{tooltip}</div>
      </Popper>
    </>
  );
};
